import { Component, OnInit } from "@angular/core";
import { ViewController } from "ionic-angular";

@Component({
  selector: "patient-charts-modal",
  templateUrl: "patient-charts.modal.html"
})
export class PatientChartsModal implements OnInit {
  constructor(
    private viewCtrl: ViewController
  ) {}

  ngOnInit() {}

  dismiss($event) {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/modals/patient-charts.modal/patient-charts.modal.ts